import { format } from 'date-fns';
/** Formate une date (string ISO ou Date) en dd/MM/yyyy pour l'affichage */
export function formatDateDisplay(value) {
    const date = value instanceof Date ? value : new Date(value);
    return format(date, 'dd/MM/yyyy');
}
/** Convertit un Date en string YYYY-MM-DD timezone-safe (utilise le fuseau local) */
export function toDateOnlyString(date) {
    return format(date, 'yyyy-MM-dd');
}
